/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import DocumentRevision from 'shared/ui/components/dev-tools/document-editor/DocumentRevision.vue';

const __vue_script__ = {
    name: 'DocumentRevisions',

    components: { DocumentRevision },

    props: {
        document: {
            type: Object,
            required: true
        },

        eventId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            revisions: []
        };
    },

    computed: {
        showRevisions() {
            return Boolean(this.revisions.length);
        },

        latestRev() {
            return this.revisions[0]?.rev;
        }
    },

    watch: {
        document: {
            immediate: true,
            handler() {
                this.loadRevisions();
            }
        }
    },

    methods: {
        loadRevisions() {
            const document = this.document;

            if (document._revs_info) {
                this.revisions = this.formatRevisions(document);
                this.$emit('ready');
            }
        },

        /**
         * Formats the revisions of a document
         *
         * @param {Object} document
         * @returns {Array} Formatted revisions
         * @memberof DocumentEditor
         */
        formatRevisions(document) {
            const revs = document._revs_info;
            if (!revs) return [];

            return document._revs_info.map(rev => {
                const [n, id] = rev.rev.split('-');
                rev.n = n;
                rev.id = id;
                return rev;
            });
        },

        /**
         * Handler for selecting a specific revision
         *
         * @param {object} revision the selected revision
         */
        onRevisionSelected(revision) {
            if (revision.status === 'available') {
                this.$emit('select', this.document._id, revision.rev);
            }
        },

        /**
         * Handler for the revision comparison
         *
         * @param {object} revision the revision to compare
         */
        onCompareRevision(revision) {
            this.$emit('compare', this.document._id, this.document._rev, revision.rev);
        },

        /**
         * Handler for the revision restoration
         *
         * @param {object} revision the revision to restore
         */
        onRestoreRevision(revision) {
            this.$modal.show('dialog', {
                text: this.$t('dev_tools.document_editor.revision_restore', [revision.rev]),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('dev_tools.document_editor.restore_revision'),
                        handler: () => {
                            this.restoreRevision(revision);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        async restoreRevision(revision) {
            try {
                await this.$services.appScripts.callAppScript(this.eventId, 'dev-tools/restore-revision', {
                    id: this.document._id,
                    rev: revision.rev,
                    latestRev: this.document._rev
                });

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('dev_tools.document_editor.revision_restored').toString(),
                    type: 'success',
                    duration: 5000
                });

                this.$emit('select', this.document._id);
                this.$emit('restored', this.document._id, revision.rev);

            } catch (error) {
                console.error('[DocumentPanel] Could not restore revision', error.message);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('dev_tools.document_editor.revision_not_restored').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showRevisions
    ? _c(
        "div",
        { staticClass: "document-revisions" },
        [
          _c("h4", [
            _vm._v(
              _vm._s(_vm.$t("dev_tools.document_editor.revisions")) +
                " (" +
                _vm._s(_vm.revisions.length) +
                ")"
            ),
          ]),
          _vm._l(_vm.revisions, function (rev) {
            return _c("document-revision", {
              key: rev.id,
              class: { selected: rev.rev === _vm.document._rev },
              attrs: {
                revision: rev,
                current: _vm.document._rev,
                latest: _vm.latestRev,
              },
              on: {
                compare: _vm.onCompareRevision,
                restore: _vm.onRestoreRevision,
                selected: _vm.onRevisionSelected,
              },
            })
          }),
        ],
        2
      )
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/dev-tools/document-editor/DocumentRevisions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__